import React from "react"
import { useQuery } from '@tanstack/react-query'
import axios from 'axios'


export default () => {
  const { isPending, data: { schedule: { weeks, missingSlugs } = {} } = {} } = useQuery({
    queryKey: ['dodones_resolver', 'day'],
    queryFn: async () => {
      const response = await axios.get(`/api/dodones_resolver/day.json`);
      return response.data;
    },
    onError: (data) => {
    }
  })

  if(isPending) return <div> Loading </div>

  return <>
           <div className='fcol'>
             {
               Object.entries(weeks).map(([index, week]) => {
                 return <Week key={ index } week={ week } />
               })
             }
           </div>
           <div>
             {
               missingSlugs.length == 0 ? null :
                 <>
                   <div className="text-red-500"> Missing Slugs: </div>
                   {
                     Object.entries(missingSlugs).map(([index, missingSlug]) => {
                       return <div key={ index }> { missingSlug } </div>
                     })
                   }
                 </>
             }
           </div>
         </>
}


const Week = ({ week }) => {
  return <div className="frow mb-d">
           {
             Object.entries(week).map(([index, weekDay]) => {
               return <WeekDay key={ index } weekDay={ weekDay } />
             })
           }
         </div>;
}

const WeekDay = ({ weekDay }) => {
  return <div className="fcol flex-1">
           <div className={clsx({ 'text-green-800': weekDay.today })}> { weekDay.day } ( { weekDay.cycleDayNumber } ) </div>
           {
             Object.entries(weekDay.dodonesAttributes).map(([index, dodoneAttributes]) => {
               return <div className={ clsx('text-xs pr-d py-1', { 'bg-gray-400': (index % 2) == 1 }) } key={ index }>{ dodoneAttributes.slug }</div>
             })
           }
         </div>;
}
